jQuery(document).ready(function($) {
    function nfCloseLightbox() {
        $('.nf-lightbox__backdrop').fadeOut(300);
        $('.nf-lightbox').fadeOut(300);
        window.player.pauseVideo();
    }

    $('.nf-lightbox__close').on('click', function(e) {
        e.preventDefault();
        nfCloseLightbox();
    });

    $('.podcast-card__image.has-video').on('click', function(e) {
        e.preventDefault();
        let videoUrl = $(this).prop('href');
        $('.nf-lightbox__backdrop').fadeIn(300);
        $('.nf-lightbox').fadeIn(300);

        let videoId = videoUrl.split('/embed/')[1];

        if ( window.player.getVideoUrl().includes(videoId) ) {
            window.player.playVideo();
            return;
        }

        window.player.loadVideoById(videoId);
        window.player.playVideo();
    });

    $('.nf-lightbox__backdrop').on('click', function(){
        nfCloseLightbox();
    });

    /*
    $('.single-post__player__overlay').on('click', function(){
        for (let i in window.players) {
            window.players[i].pauseVideo();
        }

        let index = 0;
        if ( ! $('body').hasClass('single-post') ) {
            const player_div = $(this).closest('.podcast-card');
            index = $('#content').find(player_div).index();
        }
        
        $(this).fadeOut(300);
        window.players[index].playVideo();
    });
    */
});